import { useEffect, useState } from "react";
import { requestGetEnvironmentTypeList } from "services/acadReinforce/relatedToAcadReinforce";
import { requestGetAllCampusDetail } from "services/general";

export const useDataRelatedToForm = () => {
    const [campusDetailList, setCampusDetailList] = useState([]);
    const [environmentTypeList, setEnvironmentTypeList] = useState([]);
    useEffect(() => {
        Promise.all([
            fillCampusDetailList(),
            fillEnvironmentTypeList()
        ]);
    }, []);
    const fillCampusDetailList = async () => {
        const data = await requestGetAllCampusDetail();
        setCampusDetailList(data);
    }
    const fillEnvironmentTypeList = async () => {
        const data = await requestGetEnvironmentTypeList();
        setEnvironmentTypeList(data);
    }
    return {
        campusDetailList,
        environmentTypeList
    };
}

export default useDataRelatedToForm;